import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'
import './DownloadFiles.sass'

export default class DownloadFiles extends React.PureComponent {
  /* eslint-disable */
  static propTypes = {
    arrayFiles: PropTypes.array.isRequired,
    id: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    format: PropTypes.string,
    size: PropTypes.string,
    style: PropTypes.string
  }
  /* eslint-disable */

  render() {
    const {arrayFiles, vertical} = this.props
    if (!arrayFiles) {
      return null
    }
    return (
      <div className={`download-files-wrapper ${vertical? 'download-files-wrapper-vertical' : ''}`}>
        {arrayFiles && arrayFiles.map((file) => {
          return (
            <a key={file.id} href={file.url} target="_blank" className={`download-files__item download-files__item-${file.size}`}>
              <div className="item__img">
                <Icon type={file.format || 'all'}/>
              </div>
              <div className="item__text">
                <p className="item__name">{file.title}</p>
                <p className="item__download">Скачать</p>
              </div>
            </a>
          )
        })
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/DownloadFiles/index.jsx